// NotificationProvider.js
import React, { createContext, useContext, useState } from 'react';
import '../styles/NotificationProvider.css';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((notif) => notif.id !== id));
  };

  const addNotification = (message, type = 'success', duration = 3000, action = null) => {
    const id = Date.now();
    const notification = { id, message, type, duration, action };

    setNotifications((prev) => [...prev, notification]);

    setTimeout(() => {
      removeNotification(id);
    }, duration);
  };

  const handleAction = (notification) => (event) => {
    event.stopPropagation();
    if (notification?.action && typeof notification.action.onAction === 'function') {
      notification.action.onAction();
    }
    removeNotification(notification.id);
  };

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <div className="notification-container">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification ${notification.type}`}
            style={{ '--toast-duration': `${notification.duration}ms` }}
            onClick={() => removeNotification(notification.id)}
          >
            <span className="notification-message">{notification.message}</span>
            {notification.action && (
              <button
                type="button"
                className="notification-action"
                onClick={handleAction(notification)}
              >
                {notification.action.label || 'OK'}
              </button>
            )}
            <button
              type="button"
              className="notification-close"
              aria-label="Fermer la notification"
              onClick={(event) => {
                event.stopPropagation();
                removeNotification(notification.id);
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
